import React, { useState } from 'react';
import Title from './Title';
import { Input, Box } from '../index';

const variantOptions = [
  { value: 'primary', label: 'Primary' },
  { value: 'secondary', label: 'Secondary' },
  { value: 'success', label: 'Success' },
  { value: 'danger', label: 'Danger' },
  { value: 'warning', label: 'Warning' },
  { value: 'info', label: 'Info' },
  { value: 'dark', label: 'Dark' }
];

const titleVariantOptions = [
  { value: 'primary', label: 'Primary' },
  { value: 'secondary', label: 'Secondary' },
  { value: 'dark', label: 'Dark' }
];

const sizeOptions = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' }
];

const TitleDemo = () => {
  const [inputValue, setInputValue] = useState('Liquid Glass Title');
  const [titleVariant, setTitleVariant] = useState('primary');
  const [size, setSize] = useState('large');

  return (
    <div style={{
      minHeight: '100vh',
      background: `
        linear-gradient(135deg, #667eea 0%, #764ba2 100%),
        radial-gradient(circle at 20% 80%, #f093fb 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, #f5576c 0%, transparent 50%),
        radial-gradient(circle at 40% 40%, #4facfe 0%, transparent 50%)
      `,
      backgroundBlendMode: 'overlay, screen, screen, screen',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '40px',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      {/* Interactive Title Test Section */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        width: '100%',
        maxWidth: '500px',
        background: 'rgba(255,255,255,0.07)',
        borderRadius: '18px',
        padding: '32px 24px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.10)'
      }}>
        <h2 style={{ color: 'white', margin: 0, fontWeight: 600 }}>Test Your Title</h2>
        <Input
          label="Title Text"
          placeholder="Type your title..."
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
        />
        <div style={{ width: '100%', display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
          <label style={{ color: 'white', fontWeight: 500 }}>Size:</label>
          <select
            value={size}
            onChange={e => setSize(e.target.value)}
            style={{
              padding: '8px 16px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              fontSize: '1rem',
              outline: 'none',
            }}
          >
            {sizeOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          <label style={{ color: 'white', fontWeight: 500 }}>Variant:</label>
          <select
            value={titleVariant}
            onChange={e => setTitleVariant(e.target.value)}
            style={{
              padding: '8px 16px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              fontSize: '1rem',
              outline: 'none',
            }}
          >
            {titleVariantOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        <Box variant="primary" size="medium" style={{ width: '100%', marginTop: 16, textAlign: 'center' }}>
          <Title variant={titleVariant} size={size}>{inputValue || 'Your Title Here'}</Title>
        </Box>
      </div>
      {/* Existing demo content below */}
      <div style={{ textAlign: 'center', color: 'white', marginBottom: '20px' }}>
        <Title size="large" variant="primary" as="h1">Liquid Glass Title</Title>
        <p style={{ fontSize: '1.2rem', opacity: 0.9, margin: '10px 0 0 0', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
          Elegant glassmorphism titles for your UI
        </p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%', maxWidth: '800px' }}>
        <Title size="medium" variant="primary" as="h2">Primary Title (h2)</Title>
        <Title size="medium" variant="secondary" as="h2">Secondary Title (h2)</Title>
        <Title size="medium" variant="dark" as="h2">Dark Title (h2)</Title>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '24px', width: '100%', maxWidth: '800px', justifyContent: 'center' }}>
        <Title size="small" variant="primary" as="h3">Small Title</Title>
        <Title size="medium" variant="primary" as="h3">Medium Title</Title>
        <Title size="large" variant="primary" as="h3">Large Title</Title>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%', maxWidth: '800px' }}>
        <Title size="medium" variant="primary" as="h4">h4 Title</Title>
        <Title size="medium" variant="primary" as="h5">h5 Title</Title>
        <Title size="medium" variant="primary" as="h6">h6 Title</Title>
      </div>
    </div>
  );
};

export default TitleDemo; 